import { Injectable } from '@angular/core';

import { environment } from '@finverity/platform-app/env/environment';
import type {
  FinEnvironmentName,
  IFinEnvironment,
  IFinEnvironmentApiConfig,
  IFinEnvironmentFirebaseConfig,
  IFinEnvironmentGoogleMapsConfig,
  IFinEnvironmentPlatformConfig,
  IFinEnvironmentSentryConfig,
  IFinEnvironmentStonlyConfig,
  IFinEnvironmentUserSnapConfig,
} from '@finverity/platform-app/env/environment-types';

@Injectable({ providedIn: 'root' })
export class FinEnvironmentService implements IFinEnvironment {
  get name(): FinEnvironmentName {
    return environment.name;
  }

  get production(): boolean {
    return environment.production;
  }

  get isSaaSProject(): boolean {
    return environment.isSaaSProject;
  }

  get api(): IFinEnvironmentApiConfig {
    return environment.api;
  }

  get platform(): IFinEnvironmentPlatformConfig {
    return environment.platform;
  }

  get sentry(): IFinEnvironmentSentryConfig {
    return environment.sentry;
  }

  get firebase(): IFinEnvironmentFirebaseConfig {
    return environment.firebase;
  }

  // this implemented as part of the IFinEnvironment interface
  get stonly(): IFinEnvironmentStonlyConfig {
    return environment.stonly;
  }

  // static needs to be called in main.ts
  static get stonly(): IFinEnvironmentStonlyConfig {
    return environment.stonly;
  }

  // this implemented as part of the IFinEnvironment interface
  get userSnap(): IFinEnvironmentUserSnapConfig {
    return environment.userSnap;
  }

  get googleMaps(): IFinEnvironmentGoogleMapsConfig | undefined {
    return environment.googleMaps;
  }
}
